import React from 'react';
import { DropDown } from '../../../../common/dropdown';
import { connect } from 'react-redux';
import { REDUCER_NAME, changeIndex } from './../../reducer';
import { isNotLogin } from '../../../../helpers/Common';
import EventEmitter, {
  SHOW_GUEST_POPUP,
} from '../../../../helpers/EventEmitter';

const mapStateToProps = state => {
  return {
    currentIndustry: state[REDUCER_NAME].currentIndustry,
    listIndustry: state[REDUCER_NAME].listIndustry,
    listIndustryByKey: state[REDUCER_NAME].listIndustryByKey,
    watchListId: state[REDUCER_NAME].watchListId,
    user: state.userInfo,
  };
};

const mapDispatchToProps = {
  changeIndex,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FilterIndustry);

function FilterIndustry(props) {
  const className = isNotLogin(props.user) ? 'locked-dropdown' : '';
  const onClick = () => {
    if (isNotLogin(props.user)) {
      EventEmitter.dispatch(SHOW_GUEST_POPUP);
    }
  };

  return (
    <div onClick={onClick} className={className}>
      <DropDown
        id={props.watchListId}
        keyTitle="text"
        listKey={props.listIndustry}
        listDataByKey={props.listIndustryByKey}
        currentKey={props.currentIndustry}
        change={props.changeIndex}
        isI18n={true}
      />
    </div>
  );
}
